import useSWR from 'swr';
import { getFile } from '../services/portal';

type LogoProps = {
  fileHash: string;
  boardId: number;
  position?: string;
};

export function Logo({ fileHash, boardId, position = 'left' }: LogoProps) {
  const {
    data: fileSettings,
    isLoading,
    error,
  } = useSWR(
    fileHash ? `/file/${fileHash}` : null,
    async () => {
      return await getFile(boardId, fileHash);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  if (error) {
    return <div>Error</div>;
  }

  if (isLoading) {
    return <div></div>;
  }

  if (!fileSettings) {
    return null;
  }

  return (
    <div
      style={{
        padding: position === 'center' ? '0 14px' : '0',
        width: '100%',
        height: '45%',
      }}
    >
      <img
        // base64 encoded image
        src={`${fileSettings.content}`}
        width=""
        height=""
        alt=""
        style={{
          pointerEvents: 'none',
          userSelect: 'none',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: position,
        }}
      />
    </div>
  );
}
